// extracted by mini-css-extract-plugin
export var dropdownIcon = "_sd-6";
export var imgContainer = "_sd-3";
export var menuIcon = "_sd-5";
export var pillWrapper = "_sd-2";
export var pillsContainer = "_sd-1";
export var subscriptionCard = "_sd-0";
export var subscriptionLogo = "_sd-4";